import { render, staticRenderFns } from "./BtButton.vue?vue&type=template&id=7fe30912&scoped=true&lang=pug"
import script from "./BtButton.vue?vue&type=script&lang=js"
export * from "./BtButton.vue?vue&type=script&lang=js"
import style0 from "./BtButton.vue?vue&type=style&index=0&id=7fe30912&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe30912",
  null
  
)

export default component.exports